import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 36px;
`;



// WEBPACK FOOTER //
// ./src/pages/DebriefAssignments/components/DebriefNewListItem/style.js